

<section class="features-area pt-100 pb-70 bg-f4f6fc">
    <div class="container max-width-1290">
        <div class="section-title">
            <h2>Our Products</h2>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <a class="features-box-one wow fadeInLeft" data-wow-delay=".1s"
                    routerLink="/travel" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    <!-- <i class='bx bx-cog bg-13c4a1'></i> -->
                    <i class='bx bxs-map bg-13c4a1' aria-hidden="true"></i>
                    <h3>Travel</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor dolore magna.</p>
                </a>
            </div>
            <div class="col-lg-4 col-md-6">
                <a class="features-box-one wow fadeInLeft" data-wow-delay=".2s"
                    routerLink="/automative" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    <!-- <i class='bx bxs-check-shield bg-6610f2'></i> -->
                    <i class='bx bxs-car-mechanic bg-6610f2' aria-hidden="true"></i>
                    <h3>Automative</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor dolore magna.</p>
                </a>
            </div>
            <div class="col-lg-4 col-md-6">
                <a class="features-box-one wow fadeInLeft" data-wow-delay=".3s"
                    routerLink="/social" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    <!-- <i class='bx bx-timer bg-ffb700'></i> -->
                    <i class='bx bxs-message-rounded-dots bg-ffb700' aria-hidden="true"></i>
                    <h3>Social</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor dolore magna.</p>
                </a>
            </div>
        </div>
    </div>
</section>

